import elliemaeApi from "./interceptors/elliemaeApi";

/**
 * Get service orders for a loan
 * @param {string} accessToken
 * @param {string} loanId
 * @returns {Promise<Array>}
 */
export const getServiceOrders = async (accessToken, loanId) => {
    if (!accessToken) {
        console.warn("No Access Token Available.");
        return [];
    }

    const url = `/encompass/v3/loans/${loanId}/serviceOrders`;

    try {
        const response = await elliemaeApi.get(url, {
            headers: {
                Authorization: `Bearer ${accessToken}`,
                "Content-Type": "application/json",
            },
        });

        return Array.isArray(response.data) ? response.data : [];
    } catch (error) {
        console.error("Error getting service orders:", error.message);
        throw error;
    }
};

export const hasFulfilledClosingFeeOrder = (serviceOrders = []) => {
    return serviceOrders.some(order =>
        order?.serviceSetup?.category === "CLOSINGFEES" &&
        order?.status?.toString().trim().toLowerCase() === "fulfilled"
    );
};